// extracted by mini-css-extract-plugin
module.exports = {"secondary":"SecondaryButton--secondary--7zESA"};